import Icon from 'veui/components/Icon'

Icon.register({
  edit: {
    raw: '<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path stroke="currentColor" stroke-width="4" d="M2 46h10l34-34L36 2 2 36z"/><path d="M30 8l10 10" stroke="currentColor" stroke-width="4"/></g>',
    width: '48',
    height: '48'
  }
})
